import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
export default function Datatablenoresults() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "my-5 py-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "table-no-result mx-auto mb-4"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-center fs-24 tc-13",
                children: "ไม่มีรายการ"
            })
        ]
    });
}
;
